<template>
  <v-card color="accent" dark class="body-2 py-1">

    <v-layout row wrap class="pl-2 pt-2">

      <v-flex class="shrink">
        <v-btn icon small @click="goToPrevMonth">
          <v-icon>navigate_before</v-icon>
        </v-btn>
        <v-btn icon small @click="goToNextMonth">
          <v-icon>navigate_next</v-icon>
        </v-btn>
      </v-flex>

      <v-flex class="shrink">
        <date-picker v-model="internalValue" type="month" class="input--dense" :locale="$i18n.locale"
                     append-icon="arrow_drop_down" solo-inverted dark flat :clearable="false"/>
      </v-flex>

      <v-flex class="shrink">
        <v-btn flat class="ma-0" @click="resetToToday"
               style="height: 36px; background-color: rgba(255, 255, 255, 0.16);">
          {{ $t('label.oggi') }}
        </v-btn>
      </v-flex>

      <v-flex class="shrink">
        <v-progress-circular indeterminate v-show="loading"/>
      </v-flex>

    </v-layout>

    <div class="calendar-header-container">
      <div class="text-xs-center text-capitalize caption" v-for="weekDay in weekDays" :key="weekDay">{{weekDay}}</div>
    </div>

  </v-card>
</template>

<script>
import currentDateMixin from './calendar-mixin'
import { DatePicker } from '@/components/inputs'

export default {
    name: 'CalendarHeader',
    mixins: [currentDateMixin],
    components: { DatePicker },
    props: {
        loading: Boolean
    },
    data: function () {
      return {
          weekDays: []
      }
    },
    created () {
      this.updateWeekDays()
    },
    watch: {
      '$i18n.locale': function () {
        this.updateWeekDays()
      }
    },
    methods: {
        updateWeekDays() {
          this.weekDays = [] // Resetta i giorni della settimana
          let d = new Date(1900, 0, 1) // Il 01/01/1900 è un lunedì
          while (this.weekDays.length < 7) {
            this.weekDays.push(this.$d(d, 'weekday').capitalize())
            d.setDate(d.getDate() + 1)
          }
        },
        resetToToday () {
            this.internalValue = this.$utils.date.getSqlCurrentMonth()
        }
    }
}
</script>

<style lang="scss">
  .calendar-header-container {
    width: 100%;
    display: flex;

    div {
      flex-direction: column;
      display: flex;
      flex: 1;
    }
  }
</style>
